import { Button } from "common/commonIndex";
import { Image } from "components/componentIndex";
import React, { useEffect, useRef } from "react";
import CloseIcon from '../../assets/images/doctorProfile/close-icon.svg';
import callToSchedule from '../../assets/images/call-to-schedule.svg';

const CompletedPopup = ({ selectedVisit, closeFullScreens }) => {
    const popupRef = useRef(null);

    const handleClose = () => {
        closeFullScreens();
    }
    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                closeFullScreens(false);
            }
        };

        document.addEventListener("mousedown", handleOutsideClick);
        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, [handleClose]);



    return (
        <div className="fullscreen-overlay">
            <div className={`fullscreen-overlay-content alert-fullscreen-overlay ${selectedVisit?.status === 'Denied' ? 'call-to-schedule' : selectedVisit.status === 'Completed' ? 'completed' : 'default-height'}`} ref={popupRef}>
                {selectedVisit?.status === 'Denied' && (
                    <>
                        <div className="d-flex justify-content-between align-items-center mb-5">
                            <span onClick={handleClose}>
                                <Image imgUrl={CloseIcon} altText={''} className={'popup-close-icon cursor-pointer'} />
                            </span>
                            <h5 className="sub-title mb-0">
                                {selectedVisit?.mainTitle}
                            </h5>
                            <div></div>
                        </div>
                        <Image imgUrl={callToSchedule} altText={''} className={''} />
                    </>
                )}

                <h2 className={`title ${selectedVisit?.status === 'Requested' ? '' : 'mt-3'}`}>
                    {selectedVisit?.title}
                </h2>
                <div className="alert-container">
                    <p className="alert-description">
                        {selectedVisit?.message}
                    </p>
                </div>
                <Button btnClass={`btn-primary ${selectedVisit?.buttonName?.toLowerCase() === 'call us' ? 'call-us-btn' : ''}`}
                    btnName={selectedVisit?.buttonName ? selectedVisit?.buttonName : 'Close'}
                    btnType={'button'}
                    onClick={handleClose}
                    isDisabled={true}
                />
            </div>
        </div>
    )
};

export default CompletedPopup;
